import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class UserProductTargetPricings {
  constructor($scope, UserProductService, GeoService) {
    $scope.load_target_pricings = function() {
      $scope.loading = true;
      UserProductService.get_user_products_target_pricings(window.user_id).then(function(data) {
        $scope.pricings = data.pricings;
        $scope.loading = false;
      });
    };

    $scope.add_pricing = function() {
      $scope.pricing = angular.copy(window.pricing);
      window.openFancyboxDialog('div#pricing_dialog');
    };

    $scope.edit_pricing = function(pricing) {
      $scope.pricing = pricing;
      window.openFancyboxDialog('div#pricing_dialog');
    };

    $scope.copy_pricing = function(pricing) {
      $scope.pricing = angular.copy(pricing);
      $scope.pricing.id = null;
      $scope.pricing.last_order_price_avg = 0;
      $scope.pricing.last_order_id = null;
      $scope.pricing.last_order_date = null;
      $scope.pricing.last_import_price_avg = 0;
      $scope.pricing.last_import_date = null;
      window.openFancyboxDialog('div#pricing_dialog');
    };

    $scope.save_pricing = function() {
      $scope.saving_pricing = true;
      UserProductService.save_target_pricing($scope.pricing).then(function(data) {
        if (data.success) {
          $scope.saving_pricing = false;
          $.fancybox.close();
          $scope.load_target_pricings();
        }
      });
    };

    $scope.delete_pricing = function(pricing_id) {
      if (confirm('Are you sure you want to delete this pricing?')) {
        UserProductService.delete_target_pricing(pricing_id).then(function(data) {
          if (data.success)
            $scope.load_target_pricings();
        });
      }
    };

    $scope.stock_types = [
      {
        id: 1,
        title: 'Reels'
      },
      {
        id: 0,
        title: 'Sheets'
      }
    ];

    $scope.delivery_terms = [
      {
        id: 3,
        title: 'FCA'
      },
      {
        id: 1,
        title: 'CFR'
      },
      {
        id: 2,
        title: 'DAP'
      }
    ];

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.$watch('pricing.country_id', function() {
      if ($scope.pricing && $scope.pricing.country_id) {
        GeoService.get_cities($scope.pricing.country_id).then(function(data) {
          $scope.dialog_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.pricing.city_id}))
            $scope.pricing.city_id = null;
        });
      }
    });

    $scope.update_from_last_order = function() {
      $scope.updating = true;
      UserProductService.update_target_pricings_from_last_order(window.user_id).then(function(data) {
        if (data.success) {
          $scope.updating = false;
          $scope.load_target_pricings();
        }
      });
    };

    $scope.init = function() {
      $scope.load_target_pricings();
      $scope.user_products = window.user_products;
      $scope.countries = window.countries;
    };

    $scope.init();
  }
}

UserProductTargetPricings.$inject = ['$scope', 'UserProductService', 'GeoService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-target-pricings.ctrl.js